var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchProductsComponent',{key:_vm.categoryId,attrs:{"criteria":_vm.criteria,"searchPageContent":_vm.searchPageContent,"categoryPageContent":_vm.categoryContent,"breadcrumbData":_vm.categoryId},on:{"criteriaChanged":_vm.searchProducts}}),_c('SeoFooterContent',{attrs:{"key:categoryId":""}}),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }